import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { App, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';

import { AuthProvider } from '../../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../../providers/employeerh/employeerh';
import { GoalRhProvider } from '../../../../../providers/goals/goals';


@Component({
    selector: 'page-rh-custominterview-goals',
    templateUrl: 'rh-custominterview-goals.html',
})
export class RhCustomInterviewGoalsPage implements OnInit {

    // DOMVar
    process_id: string = null;
    employee: any = null
    step: number = null;
    // Form vars
    goals: any[] = []
    showNotice: boolean = true;


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController,
        private goalRhProvider: GoalRhProvider
    ) {
        this.process_id = this.navParams.get('interview').process_id;
        this.step = this.navParams.get('interview').step;
        this.employee = this.navParams.get('interview').employee_name;
    }

    ngOnInit() {
        if (this.step > -1) {
            this.goalRhProvider.getPRHCIGoals(this.process_id).subscribe((res) => {
                if (res.success) {
                    if (res.data == null) {
                        this.goals.push({
                            name: null,
                            period: null,
                            percent_value: null
                        })
                    } else {
                        this.goals = res.data
                        this.showNotice = false;
                    }
                }
            })
        }
    }


    addGoal() {
        this.goals.push({
            name: null,
            period: null,
            goal_date: new Date().toISOString(),
            percent: null,
        })
    }

    deleteGoal(index) {
        this.goals.splice(index, 1)
    }

    setUnderstoodNotice() {
        this.showNotice = false;
    }

    // Submit :

    checkSubmitValues(goal) {
        if (
            goal.name == null ||
            goal.period == null ||
            goal.percent_value == null
        ) {
            return false;
        } else {
            return true;
        }
    }


    submit() {
        let totalPonderation = 0;
        let hasMissingValue = false;
        let hasInvalidPonderation = false;
        for (let goal of this.goals) {
            totalPonderation += +goal.percent_value;
            if (!this.checkSubmitValues(goal)) {
                hasMissingValue = true;
                let toast = this.toastCtrl.create({ message: "Erreur : certains champs sont incomplets", duration: 6000, position: 'top' });
                toast.present();
                return;
            }
        }
        if (totalPonderation !== 100) {
            hasInvalidPonderation = true;
            let toast = this.toastCtrl.create({ message: "Erreur : le total de pondération doit être de 100% et non de " + totalPonderation + "%", duration: 6000, position: 'top' });
            toast.present();
        }

        if (!hasInvalidPonderation && !hasMissingValue) {
            const process = {
                process_id: this.process_id,
                step: this.step,
                goals: this.goals
            }
            this.employeeRhProvider.saveUserPRHCIInterviewGoals(process).subscribe((res) => {
                if (res.success) {
                    let toast = this.toastCtrl.create({ message: "Les objectifs ont été sauvegarder, le collaborateur peut désormais remplir son entretien.", duration: 6000, position: 'top' });
                    toast.present();
                    this.dismiss()
                }
            })
        }



    }



    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-custominterview/rh_customerinterview-goals/rh-custominterview-goals.ts